import {MerTipoMaterialModel} from '@/models/merenda/mertipomaterial/mertipomaterial.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class MerTipoMaterialService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[], merClassificacaoId: number | null = null): Promise<AxiosResponse<DataSource<MerTipoMaterialModel>>> {
  return api.post <DataSource <MerTipoMaterialModel>>('/MerTipoMaterial/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  }, {
   params: { MerClassificacaoId: merClassificacaoId }
  });
 }

 inserirAtualizar(merTipoMaterial: MerTipoMaterialModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/MerTipoMaterial', merTipoMaterial);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/MerTipoMaterial/' + id);
 }

 atualizar(merTipoMaterial: MerTipoMaterialModel): Promise<AxiosResponse> {
  return api.put('/MerTipoMaterial', merTipoMaterial);
 }

 async get(id: number): Promise<MerTipoMaterialModel> {
  const result = await api.get<MerTipoMaterialModel>(`/MerTipoMaterial/${id.toString()}`);
  return result.data;
 }

 async DropDownList(merClassificacaoId: number | null = null) : Promise<TextoValor[]> {
  const result = await api.get('/MerTipoMaterial/DropDownList', {
   params: { MerClassificacaoId: merClassificacaoId }
  });
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
  }));
 }
}
export default new MerTipoMaterialService();
